import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
    Box,
    Button,
    Collapse,
    IconButton,
    Paper,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';

const UnspentPointsPanel = ({
    skillPoints,
    attributePoints,
    resourcePoints,
    onAllocateSkill,
    onAllocateAttribute,
    onAllocateResource,
}) => {
    const [expanded, setExpanded] = useState(false);

    const hasAnyPoints = skillPoints > 0 || attributePoints > 0 || resourcePoints > 0;
    if (!hasAnyPoints) return null;

    return (
        <Paper elevation={3} sx={{ p: 2, mb: 2 }}>

            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" alignItems="center">
                    <WarningAmberIcon
                        fontSize="small"
                        color="warning"
                        sx={{ mr: 1 }}
                    />
                    <Typography variant="subtitle1">
                        You have unspent points.
                    </Typography>
                </Box>
                <IconButton onClick={() => setExpanded(!expanded)} size="small">
                    {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Box>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Box mt={2} display="flex" flexDirection="column" gap={1}>
                    {skillPoints > 0 && (
                        <Box display="flex" justifyContent="space-between">
                            <Typography>Skill points: {skillPoints}</Typography>
                            <Button variant="contained" onClick={onAllocateSkill}>Allocate</Button>
                        </Box>
                    )}
                    {attributePoints > 0 && (
                        <Box display="flex" justifyContent="space-between">
                            <Typography>Attribute points: {attributePoints}</Typography>
                            <Button variant="contained" onClick={onAllocateAttribute}>Allocate</Button>
                        </Box>
                    )}
                    {resourcePoints > 0 && (
                        <Box display="flex" justifyContent="space-between">
                            <Typography>Resource points: {resourcePoints}</Typography>
                            <Button variant="contained" onClick={onAllocateResource}>Allocate</Button>
                        </Box>
                    )}
                </Box>
            </Collapse>
        </Paper>
    );
};

export default UnspentPointsPanel;
